"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapGallery = void 0;
const query_1 = require("./query");
class GalleryItem {
}
class CapGallery {
    static init() {
        // Z.forEach('.leddb-gallery');
        query_1.Z.init('.leddb-gallery', 'gallery-control', el => {
            return new CapGallery(el);
        });
    }
    constructor(container) {
        this.items = [];
        this.playing = true;
        this.timer = null;
        this.animationTimestamp = new Date().getTime();
        this.selectedIndex = 0;
        this.container = container;
        if (!query_1.Z.select('.fs-container').length) {
            query_1.Z.first('body').append(query_1.Z.parseHtmlAsTemplate('<div class="fs-container"></div>'));
        }
        this.fullscreenContainer = query_1.Z.first('.fs-container');
        if (query_1.Z.getData(container, 'leddb-gallery-initialised'))
            return;
        let gallery = this;
        let galleryItems = JSON.parse(query_1.Z.first(container).dataset.gallery);
        galleryItems.forEach(item => {
            this.items.push({
                href: item.Item1,
                name: item.Item2,
                caption: item.Item3,
            });
        });
        let outer = query_1.Z.parseHtmlAsTemplate(`<div class="leddb-gallery-container"></div>`);
        this.container.parentElement.after(outer);
        this.container.remove();
        outer.appendChild(this.container);
        this.outerContainer = this.container.parentElement;
        container.append(query_1.Z.parseHtmlAsTemplate(`<div class="view-panel"></div>`));
        container.append(query_1.Z.parseHtmlAsTemplate(`<div class="select-panel"></div>`));
        this.fullscreenContainer.append(query_1.Z.parseHtmlAsTemplate(`<div class="fullscreen-view"><div class="select-next"><i class="fas fa-fw fa-caret-right"></i></div><div class="close-view"><i class="fas fa-fw fa-times"></i></div><div class="caption"></div></div>`));
        this.viewPanel = query_1.Z.firstFrom(container, '.view-panel');
        this.selectPanel = query_1.Z.firstFrom(container, '.select-panel');
        this.fullView = query_1.Z.firstFrom(this.fullscreenContainer, '.fullscreen-view');
        let miniControls = query_1.Z.parseHtmlAsTemplate(`<div class="mini-controls"></div>`);
        let miniPrev = query_1.Z.parseHtmlAsTemplate(`<button type="button"><i class="fas fa-fw fa-step-backward"></i></button>`);
        let miniNext = query_1.Z.parseHtmlAsTemplate(`<button type="button"><i class="fas fa-fw fa-step-forward"></i></button>`);
        let miniPlayPause = query_1.Z.parseHtmlAsTemplate(`<button type="button" class="gallery-play-pause-button"><i class="fas fa-fw fa-pause"></i></button>`);
        this.timeoutBar = query_1.Z.parseHtmlAsTemplate(`<div class="gallery-timeout-bar"><div class="gallery-timeout"></div></div>`);
        miniPrev.addEventListener('click', ev => {
            gallery.cycle(-1);
            ev.preventDefault();
        });
        miniNext.addEventListener('click', ev => {
            gallery.cycle(1);
            ev.preventDefault();
        });
        miniPlayPause.addEventListener('click', ev => {
            gallery.playPause();
            ev.preventDefault();
        });
        miniControls.append(miniPrev);
        miniControls.append(miniPlayPause);
        miniControls.append(miniNext);
        miniControls.append(this.timeoutBar);
        this.outerContainer.append(miniControls);
        this.outerContainer.prepend(query_1.Z.parseHtmlAsTemplate(`<div class="caption"></div>`));
        this.fullViewImage = query_1.Z.parseHtmlAsTemplate(`<div class="image"></div>`);
        this.selectNext = query_1.Z.parseHtmlAsTemplate(`<div class="select-prev"><i class="fas fa-fw fa-caret-left"></i></div>`);
        this.selectPrev = query_1.Z.parseHtmlAsTemplate(`<div class="select-next"><i class="fas fa-fw fa-caret-right"></i></div>`);
        this.closeView = query_1.Z.parseHtmlAsTemplate(`<div class="close-view"><i class="fas fa-fw fa-times"></i></div>`);
        this.caption = query_1.Z.parseHtmlAsTemplate(`<div class="caption"></div>`);
        this.fullViewControls = query_1.Z.parseHtmlAsTemplate(`<div class="fullview-controls"></div>`);
        this.fullViewPlayPause = query_1.Z.parseHtmlAsTemplate(`<button class="gallery-play-pause-button"><i class="fas fa-fw fa-pause"></i></button>`);
        this.fullViewPlayPause.addEventListener('click', ev => {
            gallery.playPause();
            ev.preventDefault();
        });
        this.fullViewProgress = query_1.Z.parseHtmlAsTemplate(`<div class="gallery-timeout-bar"><div class="gallery-timeout"></div></div>`);
        this.fullViewControls.append(this.fullViewPlayPause);
        this.fullViewControls.append(this.fullViewProgress);
        this.fullView.append(this.fullViewImage);
        this.fullView.append(this.selectNext);
        this.fullView.append(this.selectPrev);
        this.fullView.append(this.closeView);
        this.fullView.append(this.caption);
        this.fullView.append(this.fullViewControls);
        this.selectPrev.addEventListener('click', ev => {
            //console.log(`[prev]`);
            ev.preventDefault();
            gallery.cycle(-1);
        });
        this.selectNext.addEventListener('click', ev => {
            //console.log(`[next]`);
            ev.preventDefault();
            gallery.cycle(1);
        });
        this.closeView.addEventListener('click', ev => this.fullView.classList.remove('active'));
        this.viewPanel.addEventListener('click', ev => {
            if (ev.target == gallery.viewPanel)
                gallery.fillScreen();
        });
        this.items.forEach((item, index) => {
            let btn = query_1.Z.parseHtmlAsTemplate(`<button data-index="${index}"></button>`);
            btn.style.backgroundImage = `url('${item.href}')`;
            btn.addEventListener('click', ev => gallery.select(index, ev.target));
            gallery.selectPanel.append(btn);
        });
        container.setAttribute('data-gallery', '');
        query_1.Z.setData(container, 'leddb-gallery-initialised', true);
        window.addEventListener('resize', ev => this.resize());
        this.resize();
        this.select(0, query_1.Z.firstFrom(this.selectPanel, 'button'));
        setTimeout(() => gallery.tick(), CapGallery.AutoCycleInterval);
        this.animate();
    }
    tick() {
        if (this.playing)
            this.cycle(1, false);
        this.resetTimeout();
    }
    animate() {
        let now = new Date().getTime();
        let delta = (now - this.animationTimestamp) / CapGallery.AutoCycleInterval;
        if (delta < 0)
            delta = 0;
        if (delta > 1)
            delta = 1;
        query_1.Z.forFirstFrom(this.outerContainer, '.gallery-timeout', el => {
            el.style.width = `${delta * 100}%`;
        });
        query_1.Z.forFirstFrom(this.fullscreenContainer, '.gallery-timeout', el => {
            el.style.width = `${delta * 100}%`;
        });
        setTimeout(() => this.animate(), 30);
    }
    resetTimeout() {
        clearTimeout(this.timer);
        query_1.Z.forFirstFrom(this.outerContainer, '.gallery-timeout', el => {
            el.style.width = '0';
        });
        query_1.Z.forFirstFrom(this.fullscreenContainer, '.gallery-timeout', el => {
            el.style.width = '0';
        });
        /*$(this.outerContainer).find('.gallery-timeout').stop().css({ width: 0 }).animate({ width: '100%' }, {
            duration: CapGallery.AutoCycleInterval,
            easing: 'linear',
        });
        $(this.fullscreenContainer).find('.gallery-timeout').stop().css({ width: 0 }).animate({ width: '100%' }, {
            duration: CapGallery.AutoCycleInterval,
            easing: 'linear',
        });*/
        this.timer = setTimeout(() => this.tick(), CapGallery.AutoCycleInterval);
    }
    resize() {
    }
    fillScreen() {
        this.fullView.classList.toggle('active');
    }
    select(index, src, andScroll = true) {
        let galleryItem = this.items[index];
        this.selectedIndex = index;
        //console.log(`select ${index}: `, galleryItem);
        query_1.Z.firstFrom(this.selectPanel, 'button').classList.remove('active');
        src.classList.add('active');
        if (andScroll) {
            src.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
            });
        }
        let item = this.items[this.selectedIndex];
        let img = document.createElement('img');
        let viewPanel = this.viewPanel;
        img.onload = ev => {
            let unique = `o-${new Date().getTime()}`;
            let over = query_1.Z.parseHtmlAsTemplate(`<div id="${unique}" class="over"></div>`);
            let fullImg = this.fullViewImage;
            fullImg.style.backgroundImage = `url('${item.href}')`;
            /*$(fullImg).fadeOut({
                duration: 200,
                complete() {
                    $(fullImg).css({
                        backgroundImage: `url('${item.href}')`,
                    }).fadeIn({
                        duration: 200,
                    });
                }
            });*/
            query_1.Z.forFirstFrom(this.outerContainer, '.caption', el => el.innerText = item.name);
            query_1.Z.forFirstFrom(this.fullscreenContainer, '.caption', el => el.innerText = item.name);
            over.style.opacity = '1';
            over.style.backgroundImage = `url('${item.href}')`;
            viewPanel.style.backgroundImage = `url('${item.href}')`;
            this.viewPanel.append(over);
            query_1.Z.forFirst(`#${unique}`, el => el.remove());
            /*over.animate({
                opacity: 1,
            }, {
                duration: 200,
                complete() {
                    $(viewPanel).css({
                        backgroundImage: `url('${item.href}')`,
                    });

                    setTimeout(() => $(`#${unique}`).remove(), 200);
                },
            });*/
        };
        img.src = item.href;
        this.resetTimeout();
    }
    playPause() {
        this.playing = !this.playing;
        this.animationTimestamp = new Date().getTime();
        //console.log(`gallery is: ${this.playing ? 'playing' : 'paused'}`);
        if (this.playing) {
            this.outerContainer.classList.remove('paused');
            query_1.Z.forFirstFrom(this.outerContainer, '.gallery-play-pause-button i', i => i.replaceWith(query_1.Z.parseHtmlAsTemplate(`<i class="fas fa-fw fa-pause"></i>`)));
            this.fullscreenContainer.classList.remove('paused');
            query_1.Z.forFirstFrom(this.fullscreenContainer, '.gallery-play-pause-button i', i => i.replaceWith(query_1.Z.parseHtmlAsTemplate(`<i class="fas fa-fw fa-pause"></i>`)));
            this.resetTimeout();
        }
        else {
            this.outerContainer.classList.add('paused');
            query_1.Z.forFirstFrom(this.outerContainer, '.gallery-play-pause-button i', i => i.replaceWith(query_1.Z.parseHtmlAsTemplate(`<i class="fas fa-fw fa-play"></i>`)));
            this.fullscreenContainer.classList.add('paused');
            query_1.Z.forFirstFrom(this.fullscreenContainer, '.gallery-play-pause-button i', i => i.replaceWith(query_1.Z.parseHtmlAsTemplate(`<i class="fas fa-fw fa-play"></i>`)));
        }
    }
    cycle(dir = 0, andScroll = true) {
        this.animationTimestamp = new Date().getTime();
        //console.log(`cycle(${dir})`);
        let index = this.selectedIndex + (dir < 0 ? -1 : dir > 0 ? 1 : 0);
        if (index >= this.items.length)
            index -= this.items.length;
        if (index < 0)
            index += this.items.length;
        //console.log(`cycle(${dir}) => [${this.selectedIndex}] -> ${index}`);
        this.select(index, query_1.Z.firstFrom(this.selectPanel, 'button'), andScroll);
    }
}
exports.CapGallery = CapGallery;
CapGallery.AutoCycleInterval = 20000;
//# sourceMappingURL=galleryView.js.map